import React from 'react';
import logo from '../assets/NHL_logo.png'; 
import avatar from '../assets/avatar.png';
import NotificationDropdown from '../components/NotificationDropdown';

function ExaminerDashboard() {
    return (
        <div>
          <meta charSet="UTF-8" />
          <meta name="viewport" content="width=device-width, initial-scale=1.0" />
          <title>Examiner Dashboard - Student Project Management</title>
          <div className="min-h-screen flex">
          <aside className="w-64 bg-white border-r border-gray-200 fixed h-full">
            <div className="px-6 py-4 border-b border-gray-200">
              <img src={logo} alt="Logo" className="h-18" />
            </div>
            <nav className="mt-6 px-3">
              <a href="#" className="flex items-center px-3 py-2 text-sm font-medium rounded-md bg-black text-white mb-1">
                <i className="fas fa-home w-5 h-5 mr-2" />
                Dashboard
              </a>
              <a href="/excourses" className="flex items-center px-3 py-2 text-sm font-medium rounded-md text-gray-600 hover:bg-gray-50 mb-1">
                <i className="fas fa-book w-5 h-5 mr-2" />
                Courses
              </a>
              <a href="/exsubmissions" className="flex items-center px-3 py-2 text-sm font-medium rounded-md text-gray-600 hover:bg-gray-50 mb-1">
                <i className="fas fa-file-alt w-5 h-5 mr-2" />
                Submissions
              </a>
            </nav>
          </aside>
            <div className="flex-1 ml-64">
              <header className="bg-white shadow-sm">
                <div className="max-w-8xl mx-auto px-4 sm:px-6 lg:px-8">
                  <div className="flex justify-between h-16">
                    <h1 className="text-xl font-semibold text-gray-900 flex items-center">Dashboard</h1>
                    <div className="flex items-center">
                    <NotificationDropdown />
                      <div className="ml-4 flex items-center">
                        <img className="h-8 w-8 rounded-full" src={avatar} alt="User" />
                        <span className="ml-2 text-sm font-medium text-gray-700">Admin User</span>
                      </div>
                    </div>
                  </div>
                </div>
              </header>
              <main className="max-w-8xl mx-auto py-6 sm:px-6 lg:px-8">
                <div className="grid grid-cols-1 gap-5 sm:grid-cols-2">
                  <div className="bg-white overflow-hidden shadow rounded-lg">
                    <div className="p-5">
                      <div className="flex items-center">
                        <div className="flex-shrink-0">
                          <i className="fas fa-book text-custom text-3xl" />
                        </div>
                        <div className="ml-5 w-0 flex-1">
                          <dl>
                            <dt className="text-sm font-medium text-gray-500 truncate">Pending Reviews</dt>
                            <dd className="text-3xl font-semibold text-gray-900">8</dd>
                          </dl>
                        </div>
                      </div>
                    </div>
                  </div>
                  <div className="bg-white overflow-hidden shadow rounded-lg">
                    <div className="p-5">
                      <div className="flex items-center">
                        <div className="flex-shrink-0">
                          <i className="fas fa-file-alt text-custom text-3xl" />
                        </div>
                        <div className="ml-5 w-0 flex-1">
                          <dl>
                            <dt className="text-sm font-medium text-gray-500 truncate">Reviews Done</dt>
                            <dd className="text-3xl font-semibold text-gray-900">16</dd>
                          </dl>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
                <div className="mt-8">
                  <div className="bg-white shadow rounded-lg">
                    <div className="px-4 py-5 sm:p-6">
                      <div className="flex justify-between items-center mb-4">
                        <h2 className="text-lg font-medium text-gray-900">Recent Courses</h2>
                        <button className="hidden" onclick="document.getElementById('course-creation-modal').classList.remove('hidden')">
                          <i className="fas fa-plus mr-2" />Add Course
                        </button>
                      </div>
                      <div className="overflow-x-auto">
                        <table className="min-w-full divide-y divide-gray-200">
                          <thead>
                            <tr>
                              <th className="px-6 py-3 bg-gray-50 text-left text-xs font-medium text-gray-500 uppercase tracking-wider">Course Name</th>
                              <th className="px-6 py-3 bg-gray-50 text-left text-xs font-medium text-gray-500 uppercase tracking-wider">Examiners</th>
                              <th className="px-6 py-3 bg-gray-50 text-left text-xs font-medium text-gray-500 uppercase tracking-wider">Deadline</th>
                              <th className="px-6 py-3 bg-gray-50 text-left text-xs font-medium text-gray-500 uppercase tracking-wider">Status</th>
                              <th className="px-6 py-3 bg-gray-50 text-left text-xs font-medium text-gray-500 uppercase tracking-wider">Actions</th>
                            </tr>
                          </thead>
                          <tbody className="bg-white divide-y divide-gray-200">
                            <tr>
                              <td className="px-6 py-4 whitespace-nowrap text-sm font-medium text-gray-900">Web Development</td>
                              <td className="px-6 py-4 whitespace-nowrap text-sm text-gray-500">Dr. Smith, Dr. Johnson</td>
                              <td className="px-6 py-4 whitespace-nowrap text-sm text-gray-500">Dec 15, 2024</td>
                              <td className="px-6 py-4 whitespace-nowrap">
                                <span className="px-2 inline-flex text-xs leading-5 font-semibold rounded-full bg-green-100 text-green-800">Active</span>
                              </td>
                              <td className="px-6 py-4 whitespace-nowrap text-sm text-gray-500"><button className="text-custom hover:text-custom-dark ml-2"><i className="fas fa-external-link-alt text-custom hover:text-custom-dark" /></button></td>
                            </tr>
                            <tr>
                              <td className="px-6 py-4 whitespace-nowrap text-sm font-medium text-gray-900">Data Structures</td>
                              <td className="px-6 py-4 whitespace-nowrap text-sm text-gray-500">Dr. Brown, Dr. Davis</td>
                              <td className="px-6 py-4 whitespace-nowrap text-sm text-gray-500">Dec 20, 2024</td>
                              <td className="px-6 py-4 whitespace-nowrap">
                                <span className="px-2 inline-flex text-xs leading-5 font-semibold rounded-full bg-yellow-100 text-yellow-800">Pending</span>
                              </td>
                              <td className="px-6 py-4 whitespace-nowrap text-sm text-gray-500"><button className="text-custom hover:text-custom-dark ml-2"><i className="fas fa-external-link-alt text-custom hover:text-custom-dark" /></button></td>
                            </tr>
                          </tbody>
                        </table>
                      </div>
                    </div>
                  </div>                 
                  </div>
              </main>
            </div>
          </div>
          <footer className="bg-white border-t border-gray-200 fixed bottom-0 w-full">
        <div className="max-w-8xl mx-auto px-4 sm:px-6 lg:px-8">
            <div className="py-4 text-center text-sm text-gray-500">
              <p>© 2024 NHL Stenden. All rights reserved.</p>
            </div>
          </div>
        </footer>
        </div>
    );
}

export default ExaminerDashboard;